import {
  configureStore,
  combineReducers,
} from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "@/data/slices/authSlice";
import tabReducer from "@/data/slices/tabsSlice";
import orgReducer from "@/data/slices/orgSlice";
import modalReducer from "@/data/slices/modalSlice";
import languageReducer from "@/data/slices/languageSlice";
import unsavedFormsReducer from "@/data/slices/unsavedFormsSlice";
import notificationsReducer from "@/data/slices/notificationsSlice";
import signalRMiddleware from "@/data/middleware/signalR";

const tabsPersistConfig = {
  key: "tabs",
  version: 1,
  storage,
  whitelist: ["order", "byId", "activeId", "closedTabs", "tabHistory"],
};

const rootReducer = combineReducers({
  orgs: orgReducer,
  modals: modalReducer,
  auth: authReducer,
  tabs: persistReducer(tabsPersistConfig, tabReducer),
  language: languageReducer,
  unsavedForms: unsavedFormsReducer,
  notifications: notificationsReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(signalRMiddleware),
});

export const persistor = persistStore(store);
